module.exports = __webpack_public_path__ + "static/media/Leseaffe.41026541.svg";